// extracted by mini-css-extract-plugin
module.exports = {"returnItem":"returnList_returnItem__tkxbz"};